<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" bottom offset-y>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <slot name="activator">
            <v-btn color="accent" block>Change Status</v-btn>
          </slot>
        </div>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Change Status</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-form v-model="Form.valid" class="px-3" data-vv-scope="Form" @submit.prevent="">
          <v-autocomplete
            dont-fill-mask-blanks
            :items="optionStatus"
            v-model="Form.status"
            :label="`${appointment.status} to`"
            item-text="name"
            item-value="value"
            v-validate="'required'"
            data-vv-name="status"
            :error-messages="errors.collect('Form.status')"
            return-object
          />
          <v-text-field label="Cancel reason" v-show="Form.status.value === 'cancelled'" v-model="Form.cancel_reason" />
          <v-checkbox
            v-if="Form.status.value === 'completed' && appointment.status !== 'incomplete'"
            v-model="Form.deduct"
            label="Deduct?"
          ></v-checkbox>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.native="close()">Cancel</v-btn>
            <v-btn text color="primary" :disabled="!Form.valid" @click.native="changeStatus()">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import appointmentService from '../services/appointment';
import AppointmentTransformer from '../transformers/appointment';
import numberUtil from '../utils/number';

export default {
  mixins: [formMixin],
  props: {
    appointment: Object,
    corporate: Object,
    value: Boolean,
  },
  data: () => ({
    menu: false,
    status: [
      { name: 'Completed', value: 'completed' },
      { name: 'Cancelled', value: 'cancelled' },
    ],
    Form: new Forms({
      data() {
        return {
          valid: false,
          status: '',
          cancel_reason: '',
          deduct: false,
        };
      },
      transformToPayload: AppointmentTransformer.changeStatus,
    }),
  }),
  computed: {
    numberUtil() {
      return numberUtil;
    },
    optionStatus() {
      const newCollection = [];
      this.status.forEach((item) => {
        if (item.value !== this.appointment.status) newCollection.push(item);
      });
      return newCollection;
    },
  },
  methods: {
    changeStatus() {
      this.$validator.validateAll('Form').then((result) => {
        if (result) {
          this.$root
            .$confirm(
              'Status',
              `Are you sure for change <b>${this.appointment.status}</b> to <b>${this.Form.status.name}</b> ?`,
              {
                color: 'primary',
              }
            )
            .then((confirm) => {
              if (confirm) {
                appointmentService
                  .changeStatus(this.appointment.id, this.Form)
                  .then((data) => {
                    this.$notify({
                      title: 'Change',
                      text: 'Status change success !!',
                      type: 'success',
                    });
                    this.$emit('success', data);
                    this.close();
                  })
                  .catch(() => {});
              }
            });
        }
      });
    },
    close() {
      this.menu = false;
      this.resetFormError(null, this.Form);
    },
  },
};
</script>
